import axios from 'axios';

const URL = 'https://api.openweathermap.org/data/2.5/weather';
const API_KEY = 'f33a484cf794d08d0148764789aaba32';

export const fetchWeather = async (query) => {
    try {
        const { data } = await axios.get(URL, {
            params: {
                q: query,
                lang: 'es',
                units: 'metric',
                APPID: API_KEY,
            }
        });
        return { data, error: null };
    } catch (error) {
        if (error.response && error.response.status === 404) {
            return { data: null, error: `Ciudad "${query}" no encontrada. Comprueba el nombre e inténtalo de nuevo.` };
        }
        return { data: null, error: 'Error al conectar con el servidor. Inténtalo más tarde.' };
    }
};